import RoutesEnum from '../../../../enums/RoutesEnum';

const account = [
    { to: RoutesEnum.LOGIN, label: 'Login' },
    { to: RoutesEnum.REGISTER, label: 'Register' },
    { to: RoutesEnum.CONTACT, label: 'Contact' },
];

export default account;
